import NsContent from 'components/common/ns-content/NsContent';
import NsImage from '@britishgasenergy/react-nucleus/dist/nuc-components/NsImage';

import { NsAccordion } from 'components/common/ns-accordion/NsAccordion';
import { NsExpander } from 'components/common/ns-expander/NsExpander';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';

import centricaMeterReadsSingle from 'assets/images/meter-reads/meter-reads-single-meter.png';
import centricaMeterReadsTwoRate from 'assets/images/meter-reads/meter-reads-two-rate-meter.png';
import centricaMeterReadsSingleDisplay from 'assets/images/meter-reads/meter-reads-single-display-meter.png';
import centricaMeterReadsDial from 'assets/images/meter-reads/meter-reads-dial-meter.png';
import centricaMeterReadsSmart from 'assets/images/meter-reads/meter-reads-smart-meter.png';
import centricaMeterReadsDigital from 'assets/images/meter-reads/meter-reads-digital-meter.png';
import centricaMeterReadsImperial from 'assets/images/meter-reads/meter-reads-imperial-meter.png';
import centricaMeterReadsGasDial from 'assets/images/meter-reads/meter-reads-gas-dial-meter.png';
import centricaMeterReadsGasSmart from 'assets/images/meter-reads/meter-reads-gas-smart-meter.png';
export const testId = 'meter-reads-guide';

export const MeterReadsGuide = () => {
  return (
    <div data-testid={testId}>
      <NsAccordion heading="How to read your meters" headingTag="h2">
        <NsExpander
          heading="Reading your electricity meter"
          headingTag="h3"
          open={false}
        >
          <NsDescriptionList>
            {[
              {
                term: (
                  <NsContent>
                    <NsImage
                      src={centricaMeterReadsSingle}
                      alt="Electricity meter"
                    />
                  </NsContent>
                ),
                description: (
                  <>
                    <p className="h4">Single rate meter</p>
                    <p>
                      The meter reading on the left is 02537. Write down the
                      five numbers shown from left to right. You can ignore the
                      number(s) which may be shown in red.
                    </p>
                  </>
                )
              },
              {
                term: (
                  <NsImage
                    src={centricaMeterReadsTwoRate}
                    alt="Electricity meter"
                  />
                ),
                description: (
                  <>
                    <p className="h4">Two rate meter</p>
                    <p>
                      The meter reading on the left is 42537, 34762. For both
                      rows write down the numbers shown from left to right. You
                      can ignore the number(s) which may be shown in red.
                    </p>
                  </>
                )
              },
              {
                term: (
                  <NsImage
                    src={centricaMeterReadsSingleDisplay}
                    alt="Electricity meter"
                  />
                ),
                description: (
                  <>
                    <p className="h4">Two rate, single display meter</p>
                    <p>
                      Some two rate meters only have one digital display and
                      they either flash up the different rate readings in a
                      cycle, or you need to press the button to make the display
                      cycle through the readings for each rate. This meter
                      reading is 11437. Write down the five numbers shown from
                      left to right for each rate.
                    </p>
                  </>
                )
              },
              {
                term: (
                  <NsImage
                    src={centricaMeterReadsDial}
                    alt="Electricity meter"
                  />
                ),
                description: (
                  <>
                    <p className="h4">Dial meter</p>
                    <p>
                      This meter reading is 64566. Read the first five dials
                      from left to right, ignoring any red dials or dials marked
                      1/10. Write down the number closest to each pointer. When
                      the pointer is between two numbers, write down the lower
                      number. If the pointer is between 9 and 0, write down 9.
                      Each dial turns in the opposite direction to the one
                      before it, so check which way each turns.
                    </p>
                  </>
                )
              },
              {
                term: (
                  <NsImage
                    src={centricaMeterReadsSmart}
                    alt="Electricity meter"
                  />
                ),
                description: (
                  <>
                    <p className="h4">Smart meter</p>
                    <p>
                      If you&apos;ve been asked to read your smart electricity
                      meter and need help, see our{' '}
                      <a href="/help-and-support/meters/how-to-take-a-reading-on-a-smart-meter">
                        How to read your smart meter help page.
                      </a>
                    </p>
                  </>
                )
              }
            ]}
          </NsDescriptionList>
        </NsExpander>
        <NsExpander heading="Reading your gas meter" headingTag="h3">
          <NsDescriptionList>
            {[
              {
                term: (
                  <NsImage
                    src={centricaMeterReadsDigital}
                    alt="Electricity meter"
                  />
                ),
                description: (
                  <>
                    <p className="h4">Digital metric meter</p>
                    <p>
                      The meter reading on the left is 00374. Write down the
                      five numbers shown from left to right. You can ignore the
                      number(s) after the decimal point which may be shown in
                      red.
                    </p>
                  </>
                )
              },
              {
                term: (
                  <NsImage
                    src={centricaMeterReadsImperial}
                    alt="Electricity meter"
                  />
                ),
                description: (
                  <>
                    <p className="h4">Imperial meter</p>
                    <p>
                      The meter reading on the left is 1374. Write down the four
                      numbers shown from left to right. You can ignore the
                      number(s) shown in red.
                    </p>
                  </>
                )
              },
              {
                term: (
                  <NsImage
                    src={centricaMeterReadsGasDial}
                    alt="Electricity meter"
                  />
                ),
                description: (
                  <>
                    <p className="h4">Dial meter</p>
                    <p>
                      This meter reading is 6456. Using the bottom row only,
                      read the four dials from left to right. Write down the
                      number closest to each pointer. If the pointer is between
                      two numbers, write down the lower number. If the pointer
                      is between 9 and 0 write down 9. Each dial turns in the
                      opposite direction to the one before it, be careful check
                      which way each turns.
                    </p>
                  </>
                )
              },
              {
                term: (
                  <NsImage
                    src={centricaMeterReadsGasSmart}
                    alt="Electricity meter"
                  />
                ),
                description: (
                  <>
                    <p className="h4">Smart meter</p>
                    <p>
                      If you&apos;ve been asked to read your smart gas meter and
                      need help, see our{' '}
                      <a href="/help-and-support/meters/how-to-take-a-reading-on-a-smart-meter">
                        How to read your smart meter help page.
                      </a>
                    </p>
                  </>
                )
              }
            ]}
          </NsDescriptionList>
        </NsExpander>
      </NsAccordion>
    </div>
  );
};
